module.exports = __webpack_public_path__ + "media/errors/404-error-e65d0fb5.png";